import store from "../store";

export function setLocationsData(data) {
  store.dispatch({ type: "SET_LOCATIONS_DATA", payload: { data } });
}

export function setZoneAndWardData(data) {
  store.dispatch({ type: "SET_ZONE_AND_WARD", payload: { data } });
}

export function getLocationSummary() {
  store.dispatch({ type: "GET_LOCATION_SUMMARY" });
}

export function setLocationSummaryData(manPowerAverage, lastManpowerCapturedAverage) {
  store.dispatch({
    type: "PUT_LOCATION_SUMMARY_DATA",
    payload: { manPowerAverage, lastManPowerCapturedAverage: lastManpowerCapturedAverage }
  });
}

export function getWorkforceCount(from, to, allowedZones) {
  store.dispatch({ type: "GET_WORKFORCE_COUNT", payload: { from, to, allowedZones } });
}
